import { render, staticRenderFns } from "./SetupAgendas.vue?vue&type=template&id=584badd8&"
import script from "./SetupAgendas.vue?vue&type=script&lang=js&"
export * from "./SetupAgendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports